import { Fragment, useState } from "react";
import { XCircle } from "react-feather";
import { CloseButton, Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";

const ErrorToast = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(!visible);
  const handleClick = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 8000);
  };
  return (
    <Fragment>
      <Btn color="danger" onClick={handleClick}>
        {"Error Toast"}
      </Btn>
      <div className="toast-container position-fixed bottom-0 end-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={visible}>
          <div className="d-flex justify-content-between align-items-center alert-light-danger">
            <ToastBody>
              <XCircle className="close-search stroke-danger" />
              {"A database connection error has occurred"}
            </ToastBody>
            <CloseButton className="me-2 m-auto" onClick={toggle} />
          </div>
        </Toast>
      </div>
    </Fragment>
  );
};

export default ErrorToast;
